<template>
  <div class="faq-list__item">
    <h4 :class="{'active':isOpen}" @click="toggleDropdown">
      <span>{{ header }}</span>
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M4.28717 10.5998C4.49912 10.2817 4.81464 10.0713 5.16433 10.0151C5.51402 9.95883 5.86923 10.0613 6.15182 10.2999L16.0078 18.6973L25.8638 10.2999C26.1464 10.0613 26.5016 9.95883 26.8513 10.0151C27.201 10.0713 27.5165 10.2817 27.7285 10.5998C27.8376 10.7582 27.9174 10.9397 27.9631 11.1335C28.0089 11.3272 28.0196 11.5293 27.9948 11.7278C27.97 11.9264 27.91 12.1173 27.8185 12.2892C27.727 12.4612 27.6058 12.6108 27.4621 12.7291L17.0467 21.6063C16.7479 21.8617 16.383 22 16.0078 22C15.6326 22 15.2678 21.8617 14.9689 21.6063L4.55355 12.7291C4.40981 12.6108 4.28861 12.4612 4.19711 12.2892C4.10561 12.1173 4.04566 11.9264 4.02083 11.7278C3.99599 11.5293 4.00677 11.3272 4.05252 11.1335C4.09827 10.9397 4.17806 10.7582 4.28717 10.5998Z" fill="#C7C7CC"/>
      </svg>
    </h4>
    <slide-up-down :active="isOpen" :duration="300">
      <div class="faq-list__item-info" v-html="content"></div>
    </slide-up-down>
  </div>
</template>

<script>
import SlideUpDown from 'vue-slide-up-down'

export default {
  name: 'FaqItem',
  components: {
    SlideUpDown
  },
  props: {
    header: String,
    content: String
  },
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    }
  }
}
</script>